import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { NumberFormat } from '@ecp/common/src/utils/utils';
import { FlexBox } from '@ecp/common/src/layouts/flex/styled';
import { Spacing } from '@ecp/common/src/layouts/Spacing';
import { TextBox } from '@ecp/common/src/text/TextBox';

const DeliverySummary = ({ label, cnt, onClick }) => {
  return (
    <Container onClick={onClick}>
      <TextBox font-size={16} font-weight={'700'} color={'#333333'}>
        {label}
      </TextBox>
      <FlexBox align-items={'baseline'}>
        <TextBox font-size={30} font-weight={'700'} color={'#6C60FF'} line-height={'30px'}>
          {NumberFormat(cnt)}
        </TextBox>
        <Spacing left={10} />
        <TextBox font-size={18} font-weight={'700'} color={'#333333'} line-height={'18px'}>
          건
        </TextBox>
      </FlexBox>
    </Container>
  );
};

export default DeliverySummary;

DeliverySummary.propTypes = {
  label: PropTypes.string,
  cnt: PropTypes.number,
  onClick: PropTypes.func,
};

const Container = styled(FlexBox)`
  width: 356px;
  height: 72px;

  justify-content: space-between;

  padding: 0 20px;
  border: 1px solid #6c60ff;
  box-shadow: 0 6px 20px rgba(200, 202, 212, 0.5);
  border-radius: 6px;
  background: #ffffff;

  &:hover {
    cursor: pointer;
  }
`;
